import type { StepConfig } from "@portal/components/multiform/types";
import type { AdminBondRequestFormData } from "../../schema";
import { PrincipalStep } from "./PrincipalStep";
import { PrincipalSummary } from "./PrincipalSummary";

export const principalStepConfig: StepConfig<AdminBondRequestFormData> = {
	name: "principal",
	label: "Principal",
	fieldPaths: ["agencyId", "agentId", "underwriterId", "followers", "suretyAccountId"],
	component: PrincipalStep,
	summaryComponent: PrincipalSummary,
};
